import { render, staticRenderFns } from "./SignatureDrawer.vue?vue&type=template&id=9f5fc96c&scoped=true"
import script from "./SignatureDrawer.vue?vue&type=script&lang=js"
export * from "./SignatureDrawer.vue?vue&type=script&lang=js"
import style0 from "./SignatureDrawer.vue?vue&type=style&index=0&id=9f5fc96c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5fc96c",
  null
  
)

export default component.exports